import './home.css';
import { useContext } from 'react';
import { UserContext } from '../context/UserContext';

export default function AGB() {
  const { user } = useContext(UserContext);
  const buttons = [
    { href: '#geltungsbereich', label: 'Geltungsbereich' },
    { href: '#anbieter', label: 'Anbieter' },
    { href: '#konto', label: 'Registrierung & Konto' },
    { href: '#leistungen', label: 'Leistungen & Portal' },
    { href: '#kostenpflichtig', label: 'Kostenpflichtige Angebote & Abos' },
    { href: '#bestellprozess', label: 'Bestellprozess & Vertragsschluss' },
    { href: '#preise-zahlung', label: 'Preise, Zahlung, Anbieter' },
    { href: '#laufzeit-kuendigung', label: 'Laufzeit & Kündigung' },
    { href: '#widerruf', label: 'Widerrufsrecht' },
    { href: '#verhaltensregeln', label: 'Verhaltensregeln' },
    { href: '#urheberrechte', label: 'Urheber- & Nutzungsrechte' },
    { href: '#haftung', label: 'Haftung' },
    { href: '#aenderungen', label: 'Änderungen der AGB' },
    { href: '#schluss', label: 'Schlussbestimmungen' },
    { href: '#kontakt', label: 'Kontakt' },
  ];

  return (
    <div className="home-page">
      {/* Hero */}
      <section id="top" className={user ? 'hero-offset-if-sidebar' : ''} style={{ width:'100vw', margin:0, padding:0 }}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin:'0 0 8px' }}>Allgemeine Geschäftsbedingungen (AGB)</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign: 'center', maxWidth:760 }}>Stand: 15.01.2026</p>
      </section>

      <section style={{ width: '100%', maxWidth: 900, margin: '0 auto', padding: '0 16px 40px 16px', color: '#fff' }}>
        {/* Inhalt / TOC */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Inhalt</h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 10 }}>
            {buttons.map(btn => (
              <a key={btn.href} href={btn.href} aria-label={`Zum Abschnitt ${btn.label}`} style={{
                fontSize: 12, lineHeight: '18px', padding: '4px 10px', borderRadius: 999,
                border: '1px solid rgba(50, 205, 137, 0.35)', color: '#d8f5e8', textDecoration: 'none',
                background: 'rgba(255,255,255,0.02)'
              }}>{btn.label}</a>
            ))}
          </div>
        </div>

        {/* 1. Geltungsbereich */}
        <div id="geltungsbereich" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">1. Geltungsbereich</h2>
          <p className="highlight-desc">
            Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für die Nutzung des AP‑Network Webportals sowie für alle hierüber angebotenen Leistungen, einschließlich kostenpflichtiger Dienste und Abopakete (zusammen „Leistungen“). Abweichende Bedingungen der Nutzer finden keine Anwendung, es sei denn, wir stimmen ihrer Geltung ausdrücklich schriftlich zu.
          </p>
        </div>

        {/* 2. Anbieter */}
        <div id="anbieter" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">2. Anbieter</h2>
          <p className="highlight-desc">
            Anbieter des Portals ist: AP‑Network UG (haftungsbeschränkt), Wittenberger Weg 17, 24941 Flensburg, Deutschland. Kontakt: kontakt@ap-n.de. Weitere Angaben findest du im <a href="/impressum" style={{ color: '#32CD89' }}>Impressum</a>.
          </p>
        </div>

        {/* 3. Registrierung & Konto */}
        <div id="konto" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">3. Registrierung & Nutzerkonto</h2>
          <p className="highlight-desc">
            Für bestimmte Funktionen ist eine Registrierung erforderlich. Du sicherst zu, bei der Registrierung wahrheitsgemäße und vollständige Angaben zu machen und deine Zugangsdaten geheim zu halten. Konten sind nicht übertragbar. Wir behalten uns vor, Konten bei Verstößen gegen diese AGB zu sperren oder zu löschen.
          </p>
        </div>

        {/* 4. Leistungen & Portal */}
        <div id="leistungen" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">4. Leistungen des Portals</h2>
          <p className="highlight-desc">
            Das Portal bietet u. a. Community‑Funktionen (z. B. Profile, Nachrichten/Chat), Wissenseinträge und Votings, Events, Downloads/Uploads sowie Integration externer Dienste (z. B. Twitch/YouTube/TikTok). Der genaue Funktionsumfang kann sich weiterentwickeln. Wir sind berechtigt, kostenlose Leistungen anzupassen, zu erweitern oder einzustellen, soweit dies für den Nutzer zumutbar ist.
          </p>
        </div>

        {/* 5. Kostenpflichtige Angebote & Abos */}
        <div id="kostenpflichtig" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">5. Kostenpflichtige Angebote & Abopakete</h2>
          <p className="highlight-desc">
            Wir bieten optional kostenpflichtige Leistungen und Abopakete an. Der jeweilige Leistungsumfang, Preise, Laufzeiten und Kündigungsfristen ergeben sich aus der jeweiligen Angebotsbeschreibung im Portal. Angebote richten sich an Verbraucher und, sofern ausgewiesen, auch an Unternehmer.
          </p>
        </div>

        {/* 6. Bestellprozess & Vertragsschluss */}
        <div id="bestellprozess" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">6. Bestellprozess & Vertragsschluss</h2>
          <p className="highlight-desc">
            Mit der Bestellung über das Portal gibst du ein verbindliches Angebot zum Abschluss eines Vertrags ab. Der Vertrag kommt zustande, sobald wir die Bestellung annehmen, z. B. durch Bestätigungsanzeige im Portal, Bestätigungs‑E‑Mail oder Freischaltung der Leistung. Im Rahmen des Bestellprozesses erhältst du eine Übersicht über Preis, Laufzeit, wesentliche Merkmale und ggf. weitere Bedingungen.
          </p>
        </div>

        {/* 7. Preise, Zahlung, Zahlungsdienstleister */}
        <div id="preise-zahlung" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">7. Preise, Zahlung & Zahlungsdienstleister</h2>
          <p className="highlight-desc">
            Alle Preise verstehen sich in Euro inkl. der jeweils gültigen gesetzlichen Umsatzsteuer, sofern nicht anders angegeben. Die verfügbaren Zahlungsarten werden im Bestellprozess angezeigt. Zur Zahlungsabwicklung können Zahlungsdienstleister eingesetzt werden; Zahlungsdaten werden in der Regel direkt beim Zahlungsdienstleister erhoben und verarbeitet. Wir erhalten transaktionsbezogene Informationen (z. B. Betrag, Status, Referenz), um die Leistung zuzuordnen.
          </p>
        </div>

        {/* 8. Laufzeit & Kündigung */}
        <div id="laufzeit-kuendigung" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">8. Laufzeit, Verlängerung & Kündigung</h2>
          <p className="highlight-desc">
            Sofern nicht anders angegeben, haben Abos eine feste Laufzeit (z. B. monatlich) und verlängern sich jeweils automatisch um die ursprüngliche Laufzeit, wenn sie nicht fristgerecht gekündigt werden. Die Kündigungsfrist ergibt sich aus der Angebotsbeschreibung; mangels Angabe gilt die gesetzliche Frist. Kündigungen können im Portal (sofern verfügbar) oder per E‑Mail erklärt werden und wirken zum Ende der jeweiligen Laufzeit. Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.
          </p>
        </div>

        {/* 9. Widerrufsrecht */}
        <div id="widerruf" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">9. Widerrufsrecht für Verbraucher</h2>
          <p className="highlight-desc">
            Verbrauchern steht bei Fernabsatzverträgen grundsätzlich ein 14‑tägiges Widerrufsrecht zu. Näheres (Widerrufsbelehrung, Muster‑Widerrufsformular) stellen wir im Bestellprozess bereit. Bei digitalen Inhalten/Services kann das Widerrufsrecht vorzeitig erlöschen, wenn wir mit deiner ausdrücklichen Zustimmung vor Ablauf der Widerrufsfrist mit der Ausführung beginnen und du deine Kenntnis vom Erlöschen bestätigt hast.
          </p>
        </div>

        {/* 10. Verhaltensregeln */}
        <div id="verhaltensregeln" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">10. Verhaltensregeln & verbotene Inhalte</h2>
          <ul className="highlight-desc" style={{ marginTop: 8, listStyle: 'none', paddingLeft: 0 }}>
            <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              <span aria-hidden="true" style={{ color: '#32CD89', marginTop: 2 }}>✔</span>
              <span>Keine rechtswidrigen, beleidigenden, diskriminierenden oder jugendgefährdenden Inhalte</span>
            </li>
            <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              <span aria-hidden="true" style={{ color: '#32CD89', marginTop: 2 }}>✔</span>
              <span>Kein Spam, keine Malware, keine Eingriffe in die IT‑Sicherheit des Portals</span>
            </li>
            <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              <span aria-hidden="true" style={{ color: '#32CD89', marginTop: 2 }}>✔</span>
              <span>Respektvoller Umgangston, Schutz von Rechten Dritter</span>
            </li>
          </ul>
          <p className="highlight-desc" style={{ marginTop: 8 }}>
            Bei Verstößen sind wir berechtigt, Inhalte zu entfernen, Nutzer temporär zu sperren oder Konten dauerhaft zu löschen. Gesetzliche Ansprüche bleiben unberührt.
          </p>
        </div>

        {/* 11. Urheber- & Nutzungsrechte */}
        <div id="urheberrechte" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">11. Urheber- & Nutzungsrechte</h2>
          <p className="highlight-desc">
            Inhalte des Portals (Texte, Grafiken, Software, Marken) sind urheber‑ bzw. kennzeichenrechtlich geschützt. Soweit nicht ausdrücklich erlaubt, ist ihre Nutzung außerhalb des Portals untersagt. Für von Nutzern eingestellte Inhalte räumt der Nutzer uns ein einfaches, räumlich unbeschränktes Nutzungsrecht zur Darstellung im Portal ein; die Rechte verbleiben im Übrigen beim Nutzer. Der Nutzer sichert zu, über die erforderlichen Rechte zu verfügen.
          </p>
        </div>

        {/* 12. Haftung */}
        <div id="haftung" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">12. Haftung</h2>
          <p className="highlight-desc">
            Wir haften unbeschränkt bei Vorsatz und grober Fahrlässigkeit, bei Verletzung von Leben, Körper oder Gesundheit sowie nach dem Produkthaftungsgesetz. Bei einfacher Fahrlässigkeit haften wir nur bei Verletzung einer wesentlichen Vertragspflicht (Kardinalpflicht), und der Höhe nach beschränkt auf den bei Vertragsschluss vorhersehbaren, vertragstypischen Schaden. Im Übrigen ist die Haftung ausgeschlossen.
          </p>
        </div>

        {/* 13. Änderungen der AGB */}
        <div id="aenderungen" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">13. Änderungen der AGB</h2>
          <p className="highlight-desc">
            Wir können diese AGB anpassen, soweit sachliche Gründe dies erfordern (z. B. Weiterentwicklung des Portals, Gesetzesänderungen). Über wesentliche Änderungen werden wir informieren. Widersprichst du nicht innerhalb einer angemessenen Frist oder nutzt das Portal weiter, gelten die Änderungen als akzeptiert. Bei Änderungen zu deinem Nachteil steht dir ein Sonderkündigungsrecht zu.
          </p>
        </div>

        {/* 14. Schlussbestimmungen */}
        <div id="schluss" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">14. Schlussbestimmungen</h2>
          <p className="highlight-desc">
            Es gilt das Recht der Bundesrepublik Deutschland. Zwingende Verbraucherschutzvorschriften des Staates, in dem du deinen gewöhnlichen Aufenthalt hast, bleiben unberührt. Sollte eine Bestimmung dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
          </p>
          <p className="highlight-desc" style={{ marginTop: 10 }}>
            Informationen zur Verarbeitung personenbezogener Daten findest du in unserer <a href="/datenschutz" style={{ color: '#32CD89' }}>Datenschutzerklärung</a>.
          </p>
        </div>

        {/* 15. Kontakt */}
        <div id="kontakt" className="highlight-card" style={{ padding: 24 }}>
          <h2 className="highlight-title">15. Kontakt</h2>
          <p className="highlight-desc">
            Fragen zu diesen AGB oder zu unseren Leistungen? Schreibe uns an <a href="mailto:kontakt@ap-n.de" style={{ color: '#32CD89' }}>kontakt@ap-n.de</a> oder nutze das <a href="/kontakt" style={{ color: '#32CD89' }}>Kontaktformular</a>.
          </p>
          <div style={{ marginTop: 16 }}>
            <a href="#top" style={{ color: '#32CD89' }}>Nach oben</a>
          </div>
        </div>
      </section>
    </div>
  );
}
